import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  postRequestedWorkerDecision,
  type RequestedWorkerDecisionRequest,
} from 'api/admin/dayforce/requestedWorkerDecision'
import { shiftDetailKey } from 'queries/shifts/keys'
import { dayforceKeys } from './keys'

export const useRequestedWorkerDecisionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: RequestedWorkerDecisionRequest) =>
      postRequestedWorkerDecision(request),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: dayforceKeys.all,
      })
      await queryClient.invalidateQueries({
        queryKey: shiftDetailKey(variables.shiftId),
      })
    },
  })
}
